<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content modal-hauteur-max-75vh is-min-width-800 has-text-centered">
      <error-msg-component class="has-text-left"
                           :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'remiseBancaire.errors.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>

      <h1 class="title is-size-3">
        {{ $t('detailClient.organisation.transfertDeStock') }}
      </h1>&nbsp;
      <div class="mt-4 width-50-percent mx-auto">
          <b-field
            :label=" $t('detailClient.organisation.popup.depuis')"
            class="obligatoire">
            <b-select :disabled="false"
                  v-model="lieuDeStockageDepart"
                  expanded>
              <option :value="null"></option>
              <option
                v-for="lieuDeStock in listLieuxDeStockage"
                :value="lieuDeStock.id"
                :key="lieuDeStock.id">
                {{ lieuDeStock.nomCommercial }}
              </option>
            </b-select>
          </b-field>
      </div>

      <b-icon icon="arrow-down" class="mt-5 is-center"></b-icon>

      <div class="mt-4 mx-auto width-30">
          <b-field
            :label="$t('detailClient.organisation.popup.quantite')"
            class="obligatoire">
            <b-input type="number"
                 @input="validateQuantite"
                 v-model="quantite">
            </b-input>
          </b-field>
      </div>

      <b-icon icon="arrow-down" class="mt-5 is-center"></b-icon>

      <div class="mt-4 width-50-percent mx-auto">
          <b-field
            :label="$t('detailClient.organisation.popup.vers')"
            class="obligatoire">
              <b-select :disabled="false"
                  v-model="lieuDeStockageArrive"
                  expanded>
              <option :value="null"></option>
              <option
                v-for="lieuDeStock in listLieuxDeStockage"
                :value="lieuDeStock.id"
                :key="lieuDeStock.id">
                {{ lieuDeStock.nomCommercial }}
              </option>
            </b-select>
          </b-field>
      </div>

      <div class="mt-6">
        <qd-button @click="$parent.close()">
          {{ $t('general.button.annuler') }}
        </qd-button>
        <qd-button class="ml-6 is-addOrEdit" @click="handleTransferStock">
          {{ $t('general.button.valider') }}
        </qd-button>
      </div>
    </div>
  </div>
</template>

<script>

import { transferStockAsync } from '@/api/gabed/bonStock';
import validationTransferStock from '@/services/bonStock/validation/transferStockValidation';
import validationBonStock from '@/services/bonStock/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validation from '@/services/validation/validation';
import translate from '@/services/bonStock/validation/champsBonStockTranslator';
import messageSuccess from '@/services/general/messageSucces';

export default {
  name: 'popUpTransferStock',
  components: { errorMsgComponent },
  props: {
    tiersInformation: {
      type: Object,
      required: true,
    },
    listLieuxDeStockage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      lieuDeStockageDepart: null,
      lieuDeStockageArrive: null,
      quantite: 0,
      error: false,
      champsVide: [],
      messagesChampsVide: [],
      messages: [],
    };
  },
  methods: {
    validateQuantite() {
      if (this.quantite < 0) {
        this.quantite = 0;
      }
    },
    async handleTransferStock() {
      const query = {
        LieuDeStockageDepartId: this.lieuDeStockageDepart,
        LieuDeStockageArriveId: this.lieuDeStockageArrive,
        Quantite: this.quantite,
        ClientId: this.tiersInformation.id,
      };
      try {
        await transferStockAsync(query);
        messageSuccess(this.$i18n.t('validationBonStock.transfertEffectue'));
        this.$emit('close');
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          this.error = true;
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationTransferStock(e.response, this.messages);
          validationBonStock(e.response, this.messages);
        }
        throw (e);
      }
    },
  },
};
</script>
